
import styled, { css } from "styled-components";

import { FlexboxGrid } from "rsuite";

export const FilterSectionFlexboxGrid = styled(FlexboxGrid)
    .attrs(props => props)`
    && {
        ${props => !props.controlable ? css`
            display: flex;
            justify-content: space-between;

            margin-top: 15px;
            margin-bottom: 15px;
            margin-right: 0px !important
        ` : css`
        
        `}

        ${props => props.centered && css`
            align-items: center !important;
        `}
    }
`;

export const StyledItemFitWidth = styled(FlexboxGrid.Item)`
    &&& {

        ${props => props.isMobile ? css`
            width: 100%;

            .rs-form {
                display: block;
            }
            .rs-form-group {
                width: 100% !important;
                margin-bottom: 0 !important;
            }
            .rs-input, .rs-form-control-wrapper {
                width: 100% !important;
                margin-right: 0;
            }
            ${props => !props.noWrap ? css`
                .rs-form-control-wrapper {
                    margin-bottom: 15px;
                }

            ` : css`
                margin-bottom: 15px;
            `}
        ` : css`
            ${props => props.mr && css`
                ${props => props.group ? css`
                    .rs-form-group {
                        margin-right: ${props => props.mr}px !important;
                    }
                ` : css`
                    margin-right: ${props => props.mr}px !important;
                `}
            `}
            ${props => !props.controlable ? css`
                /* flex-grow: 1; */
            ` : css`
                display: flex;
                ${props.column ? css`
                    flex-direction: column;
                ` : css`
                    flex-direction: row;
                `}
                
                .rs-form-group {
                    margin-right: 10px;
                }
            `}
        `}
    }
`;

export const InsideFormItemsFitWidth = styled(FlexboxGrid.Item)`
    && {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .rs-form-group {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center
        }

        .rs-form-group > .rs-control-label {
            min-width: ${props => props.labelMinWidth !== undefined ? `${props.labelMinWidth}` : 100}px;
        }
    }
`;

export const StyledItemAutoMargin = styled(FlexboxGrid.Item)`
    && {
        margin-left: auto;

        ${props => props.isMobile ? css`
            display: block;
            flex: content;
    
            > * {
                width: 100%;
            }
            > *:not(:last-child) {
                margin-bottom: 10px;
            }
        ` : css`
            display: flex;
            flex: 0 0 auto;

            > *:not(:last-child) {
                margin-right: 10px;
            }
        `}
    }
`;